var app = angular.module('leonardo');

var BrowserService = function($window) {
  var service = {};

  service.isMobile = function () {
    return angular.element($window).width() < 960;
  };

  service.isTablet = function () {
    return angular.element($window).width() >= 959 && angular.element($window).width() < 1200;
  };

  return service;
};


app.factory('BrowserService', ['$window', BrowserService]);